var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.6875,
    fill: "#299FFF",
    stroke: "#C7D3DF",
    strokeWidth: 0.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.256 26.9001C25.1081 27.0267 24.8905 27.0284 24.7406 26.9042L22.5896 25.121C22.4292 24.988 22.1937 25.0004 22.0481 25.1494L13.5697 33.8286C13.3223 34.0819 13.5017 34.5081 13.8559 34.5081H35.9186C36.2707 34.5081 36.451 34.0859 36.2075 33.8315L27.8901 25.1427C27.7433 24.9894 27.5023 24.9774 27.341 25.1155L25.256 26.9001ZM29.3106 23.5739C29.129 23.7215 29.1123 23.9929 29.2746 24.1616L37.5148 32.7291C37.691 32.9122 38 32.8317 38 32.5776V17.3533C38 17.0165 37.6091 16.8305 37.3477 17.0429L29.3106 23.5739ZM12.6531 17.0094C12.3919 16.7959 12 16.9817 12 17.3191V32.5776C12 32.8322 12.3095 32.9133 12.4866 32.7304L20.7543 24.1908C20.9172 24.0226 20.9014 23.751 20.7201 23.6028L12.6531 17.0094ZM36.2987 15.7122C36.5937 15.4758 36.4266 15 36.0486 15H13.9514C13.5734 15 13.4063 15.4758 13.7013 15.7122L24.7499 24.565C24.8961 24.6822 25.1039 24.6822 25.2501 24.565L36.2987 15.7122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconFilled);
export default __webpack_public_path__ + "static/media/mailIconFilled.c50929c1622d1da80a8d820b76b75ffa.svg";
export { ForwardRef as ReactComponent };